import { gql } from "@grandvisionhq/graphql";
const INITIATE_PAYPAL_TRANSACTION = gql`
  mutation InitiatePaypalTransaction($input: InitiatePaypalTransactionInput!) {
    initiatePaypalTransaction(input: $input) {
      failures {
        ... on InitiatePaypalTransactionFailure {
          message
        }
      }
      response {
        ... on PaypalOrderResponse {
          id
          token
        }
        ... on PaypalSubscriptionResponse {
          billingAgreementTokenId
        }
      }
    }
  }
`;
export {
  INITIATE_PAYPAL_TRANSACTION
};
//# sourceMappingURL=initiate-paypal-transaction.js.map
